<template>
  <div v-if="loading"
       class="text-center justify-content-between">
    <b-spinner class="align-middle custom-text-danger mx-2"/>
    <strong>Loading...</strong>
  </div>
  <div v-else-if="!loading && isDataValid()">
    <b-row class="ma-1">
      <b-col cols="auto">
        <b-pagination v-if="pagination"
                      v-model="localCurrentPage"
                      :per-page="perPage"
                      :total-rows="dataLength"
                      size="md"/>
      </b-col>
      <b-col cols="auto">
        <slot/>
      </b-col>
    </b-row>
  </div>
  <div v-else-if="!loading && notFirstLoad">
    <component :is="`h${headerSize}`"
               class="text-center"> No data to display
    </component>
  </div>
</template>

<script>
  export default {
    name: 'BTableFooter',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      dataLength: undefined,
      currentPage: {
        type: Number,
        default: 1,
      },
      perPage: {
        type: Number,
        default: 20,
      },
      pagination: {
        type: Boolean,
        default: true,
      },
      headerSize: {
        type: Number,
        default: 1,
        validator: (val) => [1, 2, 3, 4, 5, 6].includes(val),
      },
    },
    data() {
      return {
        notFirstLoad: false,
        loading: this.value,
        localCurrentPage: this.currentPage,
      };
    },
    methods: {
      isDataValid() {
        return this.dataLength > 0;
      },
    },
    watch: {
      value() {
        this.loading = this.value;
      },
      localCurrentPage() {
        this.$emit('change-page', this.localCurrentPage);
      },
    },
    updated() {
      this.notFirstLoad = true;
    },
  };
</script>

<style scoped>

</style>
